module.exports = __webpack_public_path__ + "assets/img/20_963_big.ef5a6f1a.jpg";